import CommonTable from "../../Helpers/CommonTable";
import { redPana } from "../JodiCharts/Chart.config";
import { Nine } from "./Chart.config";

const ShreeDevi = ({ chartData }) => {

  return (
    <CommonTable
      staticData={Nine}
      chartData={chartData}
      redJodi={redPana.map((j) => parseInt(j))}
    />
  );
};

export default ShreeDevi;
